import React, { useEffect, useState } from 'react';
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

export interface MunkaszamOption {
  id: number;
  munkaszam: string;
  munkaTargya: string;
}

interface AddProjekttervezesDialogProps {
  open: boolean;
  onClose: () => void;
  options: MunkaszamOption[];
  onAdd: (munkaszamId: number) => void;
}

const AddProjekttervezesDialog: React.FC<AddProjekttervezesDialogProps> = ({
  open,
  onClose,
  options,
  onAdd,
}) => {
  const [selected, setSelected] = useState<MunkaszamOption | null>(null);

  useEffect(() => {
    if (open) {
      setSelected(null);
    }
  }, [open]);

  const handleAdd = () => {
    if (!selected?.id) {
      return;
    }
    onAdd(selected.id);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Munkaszám hozzáadása a projekttervezéshez</DialogTitle>
      <DialogContent>
        <Autocomplete
          fullWidth
          sx={{ mt: 1 }}
          options={options}
          value={selected}
          onChange={(_, value) => setSelected(value)}
          getOptionLabel={(option) =>
            `${option.munkaszam}${option.munkaTargya ? ` - ${option.munkaTargya}` : ''}`}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          filterOptions={(opts, { inputValue }) => {
            const query = inputValue.trim().toLowerCase();
            if (!query) {
              return opts;
            }
            return opts.filter((option) =>
              option.munkaszam.toLowerCase().includes(query)
              || option.munkaTargya.toLowerCase().includes(query),
            );
          }}
          disablePortal
          renderInput={(params) => (
            <TextField
              {...params}
              label="Munkaszám"
              placeholder="Kezdjen el gépelni a kereséshez..."
            />
          )}
          noOptionsText="Nincs elérhető munkaszám"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Mégse</Button>
        <Button onClick={handleAdd} variant="contained" disabled={!selected?.id}>
          Hozzáadás
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddProjekttervezesDialog;
